<template>
  <v-container fluid class="pa-6">
    <div class="d-flex justify-space-between align-center mb-1">
      <div>
        <h1 class="font-weight-bold" style="font-size: 2em;">Gerenciar Avaliações</h1>
        <div class="subtitle-2" style="color: #666;">
          Todas as avaliações feitas por pacientes e fisioterapeutas
        </div>
      </div>
    </div>

    <v-row class="mb-6" dense>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Total</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #1976d2;">
            {{ relatorio.total_avaliacoes }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Positivas</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #43a047;">
            {{ relatorio.total_avaliacoes_positivas }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Negativas</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #e53935;">
            {{ relatorio.total_avaliacoes_negativas }}
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="pa-4" outlined>
      <div class="font-weight-bold mb-3" style="font-size: 1.2em;">Lista de Avaliações</div>
      <v-row class="mb-4" dense>
        <v-col cols="12" md="3">
          <v-select
            v-model="filtroSelecionado"
            :items="opcoesFiltro"
            label="Buscar por"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="valorBusca"
            prepend-inner-icon="mdi-magnify"
            :placeholder="`Digite ${filtroSelecionado.toLowerCase()}`"
            dense
            outlined
            @keyup.enter="carregarAvaliacoes"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="carregarAvaliacoes">Buscar</v-btn>
        </v-col>
      </v-row>

      <v-simple-table>
        <thead>
          <tr>
            <th>Autor</th>
            <th>Destinatario</th>
            <th>Nota</th>
            <th>Comentário</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="avaliacoes.length === 0">
            <td colspan="6" class="text-center grey--text">
              Nenhuma avaliação encontrada
            </td>
          </tr>
          <tr v-for="(item, i) in avaliacoes" :key="i">
            <td><span class="font-weight-bold">{{ item.autor ? item.autor.nome : '---' }}</span></td>
            <td>{{ item.destinatario ? item.destinatario.nome : '---' }}</td>
            <td>
                <span class="font-weight-bold">{{ item.nota }}</span>
                <v-icon color="amber" small>mdi-star</v-icon>
            </td>
            <td>{{ item.comentario }}</td>
            <td>{{formatarDataHora (item.data) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-pagination
    v-model="pagina"
    :length="totalPaginas"
    @input="carregarAvaliacoes(false)"
    show-first-last-page
    show-page-numbers
    :total-visible="9"
    />

    <v-dialog v-model="dialogDetalhes" max-width="900">
      <DetalhesAvaliacao
        v-if="avaliacaoSelecionada"
        :avaliacao="avaliacaoSelecionada"
        @fechar="dialogDetalhes = false; carregarAvaliacoes()"
        @success="showInfo"
        @erro="showError"
      />
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>


<script>
export default {
  name: 'GerenciarAvaliacoes',
  data() {
    return {
      avaliacoes: [],
      dialogDetalhes: false,
      avaliacaoSelecionada: null,
      relatorio: {
        total_avaliacoes: 0,
        total_avaliacoes_positivas: 0,
        total_avaliacoes_negativas: 0,
      },
      opcoesFiltro: ['Nome', 'sobrenome', 'data', 'nota'],
      filtroSelecionado: 'Nome',
      valorBusca: '',
      itensPorPagina: 5,
      pagina: 1,
      totalItens: 0,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
    }
  },
  created() {
    this.carregarAvaliacoes()
    this.pegarRelatorio()
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.totalItens / this.itensPorPagina)
    },
    avaliacoesPaginadas() {
      const start = (this.pagina - 1) * this.itensPorPagina
      const end = start + this.itensPorPagina
      return this.avaliacoes.slice(start, end)
    },
  },
  methods: {
    carregarAvaliacoes(resetPage=true) {
        const campoFiltro = this.filtroSelecionado.toLowerCase()
        if (resetPage) this.pagina = 1
        const params = {
            page: this.pagina,
            page_size: this.itensPorPagina
        }
        if (this.valorBusca) {
            let valor = this.valorBusca

            if (campoFiltro === 'data') {
                const partes = this.valorBusca.split('/')
                if (partes.length === 3) {
                    valor = `${partes[2]}-${partes[1].padStart(2,'0')}-${partes[0].padStart(2,'0')}`
                }
            }
            params[campoFiltro] = valor
        }

        this.$store.dispatch('pegarAvaliacoes', params)
            .then(data => {
            const lista = Array.isArray(data) ? data : data.results || []

            this.avaliacoes = lista.map(av => {
                const notas = [av.nota_gent, av.nota_educ, av.nota_pont].filter(n => n !== null && n !== undefined)
                const media = notas.length ? parseFloat((notas.reduce((a, b) => a + b, 0) / notas.length).toFixed(1)) : null

                return {
                autor: av.autor || null,
                destinatario: av.destinatario || av.paciente || av.fisioterapeuta || null,
                nota_gent: av.nota_gent ?? null,
                nota_educ: av.nota_educ ?? null,
                nota_pont: av.nota_pont ?? null,
                nota: media,
                comentario: av.comentario || '',
                data: av.data,
                original: av
                }
            })

            this.totalItens = data.count || this.avaliacoes.length

            })
            .catch(err => console.error('Erro ao carregar avaliações:', err))
    },
    pegarRelatorio() {
      this.$store.dispatch('pegarRelatorios')
        .then(data => {
          this.relatorio = data
        })
        .catch(err => {
          console.error('Erro ao pegar relatório:', err)
        })
    },
    formatarDataHora(iso) {
      if (!iso) return ''
      const [data, hora] = iso.split('T')
      return `${data.split('-').reverse().join('/')} às ${hora.slice(0,5)}`
    },
    detalhes(item) {
      this.avaliacaoSelecionada = item.original
      this.dialogDetalhes = true
    },
    showInfo(info) {
      this.snackbar.color = 'success'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError(error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
  }
}
</script>
